// backend mappings from https://github.com/Cowbell-Cyber/fir-login/blob/master/src/main/java/com/cowbell/server/login/entities/MfaType.java
export enum MfaType {
  EMAIL = 'EMAIL',
  GOOGLE = 'GOOGLE',
  NONE = 'NONE',
  SMS = 'SMS',
}
